import { useEffect } from 'react';

import { getSimilarSoldVehicles } from 'PrivateAPI';

import { FLAG } from 'Utilities/analytics/optimizely/constants';

import { useBinaryExperiment } from '../useBinaryExperiment';

type SimilarVehiclesQuery = {
  make?: string;
  mileage?: number;
  model?: string;
  price?: number;
  year?: number;
};

export const useSimilarVehiclesDataGathering = (dpVehicleId?: number, query?: SimilarVehiclesQuery) => {
  const isEnabled = useBinaryExperiment(FLAG.OFFER_ACCEPTANCE_SIMILAR_VEHICLES, { triggerExperiment: true });

  const { make, mileage, model, price, year } = query ?? {};

  useEffect(() => {
    if (!isEnabled || !dpVehicleId || !make || mileage == null || !model || price == null || year == null) {
      return;
    }

    getSimilarSoldVehicles(dpVehicleId, { make, mileage, model, price, year }).catch(() => {});
  }, [isEnabled, dpVehicleId, make, model, mileage, year, price]);
};
